import { useRef } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';

/** allowPerfExperiment boolean for calls involving app start (use-auto-select-restaurant).
 *  We don't want 'control' to swap to 'treatment' once amplitude API call comes back because that unfairly makes 'treatment' slower because its doing twice the work.
 *  For calls to this on store locator screen amp is likely already loaded so allow the experiment */
export const useStoreLocatorPerformanceImprovements = (allowPerfExperiment = true) => {
  const { variant } = useExperiments();

  const value = allowPerfExperiment
    ? variant(RunningExperiments.StoreLocatorPerformanceImprovements, 'treatment')
    : false;

  // don't allow this value to change after dependent components mount since it could cause query issues with how this is used
  const valueRef = useRef(value);

  return valueRef.current;
};
